import { render, staticRenderFns } from "./noses.vue?vue&type=template&id=380e51f2&"
import script from "./noses.vue?vue&type=script&lang=js&"
export * from "./noses.vue?vue&type=script&lang=js&"
import style0 from "./noses.vue?vue&type=style&index=0&id=380e51f2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./noses.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports